import React from "react"

/**
 * A button for submit actions that can help prevent double-submits and display loading status.
 *
 * props:
 *   onClick: (func) action to call on click
 *   loading: (bool) should the button replace content with loader
 *   disabled: (bool) override button disabled status. Defaults to loading. If you pass this, you
 *     must account for loading yourself.
 *   type: (string) html 'type' attribute of button
 *   className: (string) className on button
 *   loadingClassName: (string) className on button in loading state
 *   fontSize, color: can be used to adjust loading spinner
 *   Other props are passed through to the <button>.
 */
export default function ButtonLoader(props) {
  const {onClick, loading, type, className, loadingClassName, children} = props
  let content, disabled, actualClassName

  if (Object.prototype.hasOwnProperty.call(props, "disabled")) {
    disabled = props.disabled
  } else {
    disabled = loading
  }

  if (loading){
    content = <div className="loading_icon button_loader">
      <svg id="button-load" x="0px" y="0px" viewBox="0 0 150 150" height={props.fontSize ? props.fontSize : '12px'} strokeWidth={props.fontSize ? props.fontSize : '12px'} stroke={props.color ? props.color : '#fff'}>
        <circle id="loading_inner" cx="75" cy="75" r="60"/>
      </svg>
    </div>
    actualClassName = loadingClassName || className
  } else {
    content = children
    actualClassName = className
  }
  const otherProps = Object.keys(props)
    .filter(k => !['children', 'className', 'type', 'loading', 'loadingClassName', 'fontSize', 'color', 'onClick'].includes(k))
    .reduce((obj, k) => Object.assign(obj, {[k]: props[k]}), {})

  return <button onClick={onClick} type={type || "button"} className={actualClassName} disabled={disabled} {...otherProps}>
    {content}
  </button>
}
